import type { U3141ChildLotChain } from '../U3141Service';

/** Nœud graphe = lot demandé du registre (BL-0702) — inverse de u3141IsGraphDeletableChildLotChain. */
export function u3141IsRequestedLotChildLotChain(
  childLotChain: U3141ChildLotChain | undefined | null,
  requestedLot: string,
): boolean {
  if (!childLotChain) return false;
  const lot = childLotChain.lotDetail?.lot?.trim() ?? '';
  const requested = requestedLot?.trim() ?? '';
  if (!requested) return false;
  return lot === requested;
}
